var React = require('react');

function Grimace (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM144,400h-8a32,32,0,0,1-32-32v-8h40Zm0-56H104v-8a32,32,0,0,1,32-32h8Zm-8-136a32,32,0,1,1,32,32A32,32,0,0,1,136,208Zm72,192H160V360h48Zm0-56H160V304h48Zm64,56H224V360h48Zm0-56H224V304h48Zm64,56H288V360h48Zm0-56H288V304h48Zm-8-104a32,32,0,1,1,32-32A32,32,0,0,1,328,240Zm64,128a32,32,0,0,1-32,32h-8V360h40Zm0-24H352V304h8a32,32,0,0,1,32,32Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M168,176a32,32,0,1,0,32,32A32,32,0,0,0,168,176Zm160,0a32,32,0,1,0,32,32A32,32,0,0,0,328,176Z","className":"fa-primary","key":2})]);
}

Grimace.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Grimace;

Grimace.default = Grimace;
